import React, { Component } from "react";
import "./App.css";
import Simplify360Chat from "./Simplify360Chat/Simplify360Chat";
import HWLogsDisplay from "./Simplify360Chat/HWLibrary/HWLogsDisplay";
import { s360ConfigService } from "./Simplify360Chat/Services/S360Config";
import {
  watchForChatSDKEvents,
  fetchConfigDetailsFromClientHost,
} from "./Simplify360Chat/Services/HWIframeBridge";
import Simplify360Tatasky from "./Simplify360Tatasky/Simplify360Tatasky";
import Login from "./Simplify360Tatasky/Login";
import ClosePopUp from "./Simplify360Tatasky/ClosePopUp";
import apiService from "./Simplify360Tatasky/APIService";

class App extends Component {
  constructor(props) {
    super(props);
    s360ConfigService.loadClientConfigFromToken();
    let configEncodedString = (window.location.pathname || "").substring(
      1,
      (window.location.pathname || "").length
    );
    const decodedString =
      s360ConfigService.decodeConfigToken(configEncodedString);
    this.state = {
      subscriberId:
        decodedString != null
          ? decodedString.subscriberId
          : s360ConfigService.getConfig.subscriberId,
      authenticated:  decodedString != null
      ? decodedString.authenticated
      : s360ConfigService.getConfig.authenticated,
      viewType: s360ConfigService.getConfig.viewType,
      sessionId: s360ConfigService.config.sessionId,
      source: s360ConfigService.config.source,
      inputbox: s360ConfigService.config.inputbox,
      action: decodedString != null ? decodedString.action : null,
      // hideLoading: decodedString != null ? decodedString.hideLoading : null,
       hideLoading: false,
      // decodedString != null ? decodedString.hideLoading : null,
      launchOnButton: decodedString != null ? decodedString.hideLoading : null,
      loginCount:0,
       openChat: decodedString != null ? decodedString.openChat : null,
    };

    //   watchForChatSDKEvents(
    //     this,
    //     () => {},
    //     () => {
    //       console.log(s360ConfigService, "CONFIG");
    //       // On Config Update Callback
    //       this.setState({
    //         subscriberId: s360ConfigService.config.subscriberId,
    //         authenticated: s360ConfigService.config.authenticated,
    //         viewType: s360ConfigService.config.viewType,
    //         sessionId: s360ConfigService.config.sessionId,
    //         source: s360ConfigService.config.source,
    //       });
    //     }
    //   );
  }
  componentDidMount() {
     
    // watchForChatSDKEvents(
    //   this,
    //   () => {},
    //   () => {
    //     // On Config Update Callback
    //     this.setState({
    //       subscriberId: s360ConfigService.config.subscriberId,
    //       authenticated: true,
    //       viewType: s360ConfigService.config.viewType,
    //       sessionId: s360ConfigService.config.sessionId,
    //       source: s360ConfigService.config.source,
    //     });
    //   }
    // );


  }
  
  render() {
    
    
    let configEncodedString = (window.location.pathname || "").substring(
      1,
      (window.location.pathname || "").length
    );
    const decodedString =
      s360ConfigService.decodeConfigToken(configEncodedString);
    // console.log(decodedString,configEncodedString,"batman",localStorage.getItem("loginDetails"));
    return (
      <>
        {/* <HWLogsDisplay/>  */}
        {/* {s360ConfigService.isConfigured() && < Simplify360Chat {...this.state}/>}  */}
        {/* < Simplify360Chat {...this.state}/>   */}

        <Simplify360Tatasky
          subscriberId={this.state.subscriberId}
          inputbox={this.state.inputbox}
          authenticated={this.state.authenticated}
          viewType={this.state.viewType}
          sessionId={this.state.sessionId}
          source={this.state.source}
          action={this.state.action}
          hideLoading={this.state.hideLoading}
          launchOnButton={this.state.launchOnButton}
          loginCount={this.state.loginCount}
           openChat ={this.state.openChat}
        />
        {/* <Login /> */}
        {/* <ClosePopUp /> */}
      </>
    );
  }

  componentDidMount() {
   
    // console.log(this.state.loginCount)
    fetchConfigDetailsFromClientHost();
   
  }
}

// generateHistoryURL = function (subscriberId) {
//   let configTokenData = { subscriberId: subscriberId, viewType: "history" }
//   let configTokenJSON = encodeURIComponent(btoa(JSON.stringify(configTokenData)));
//   let params = { configToken: configTokenJSON }
//   let urlPath = "http://simplify-360-chat-sdk-tatasky.s3-website.ap-south-1.amazonaws.com/" + JSON.stringify(Object.keys(params).map(function (k) { return params[k]; }).join('/'));
//   urlPath = urlPath.replace(/"/g, '');
//   return urlPath;
// };

// generateHistoryURL = function (subscriberId) {
//   let configTokenData = { subscriberId: subscriberId, viewType: "history" }
//   let configTokenJSON = encodeURIComponent(btoa(JSON.stringify(configTokenData)));
//   let params = { configToken: configTokenJSON }
//   let urlPath = "http:localhost:3000/" + JSON.stringify(Object.keys(params).map(function (k) { return params[k]; }).join('/'));
//   urlPath = urlPath.replace(/"/g, '');
//   return urlPath;
// };

export default App;
